export default "__VITE_ASSET__CNewb9PQ__"